import { connect } from "react-redux";
import HelpfulLinkCreate from "./HelpfulLinkCreate";
import { create } from "../../../../../redux/modules/marketing/helpfulLink";

const mdtp = { create };

const mstp = (state) => ({
    loading: state.helpfulLink.loading,
    userInfo: state.login.userInfo,
});

export default connect(mstp, mdtp)(HelpfulLinkCreate);
